import axios from 'axios'

export default {

    /**
     * Request email to reset password.
     * @param data
     * @returns {AxiosPromise<any>}
     */
    email(data) {
        return axios.post('/api/auth/password/email', data)
    },

    /**
     * Reset password using token from the email.
     * @param data
     * @returns {AxiosPromise<any>}
     */
    reset(data) {
        console.log('auth.reset', data)
        return axios.post('/api/auth/password/reset', data)
    },

    /**
     *
     * @param credentials
     */
    login(credentials) {
        let grant_params = {
            grant_type: 'password',
            client_id: window.config.client_id,
            client_secret: window.config.client_secret,//TODO hide in server-side proxy
            scope: ''
        };

        grant_params = Object.assign(grant_params, credentials);

        return axios.post('/oauth/token', grant_params);
    },

    /**
     * Log in using social account token
     *
     * @param network
     * @param access_token
     * @returns {AxiosPromise<any>}
     */
    loginSocial({ network, access_token }) {
        const grant_params = {
            grant_type: 'social',
            client_id: window.config.client_id,
            client_secret: window.config.client_secret,//TODO hide in server-side proxy
            network,
            access_token
        };

        return axios.post('/oauth/token', grant_params);
    },

    /**
     * Register user.
     * @param data
     * @returns {AxiosPromise<any>}
     */
    register(data) {
        // When file is set, set up file upload request
        if (data.file) {
            let formData = new FormData();
            Object.keys(data).forEach(key => formData.append(key, data[key]));
            data = formData;
        }
        return axios.post('/api/auth/register', data)
    },

    /**
     * Verify email token.
     * @param token
     * @returns {AxiosPromise<any>}
     */
    verify(token) {
        return axios.post('/api/auth/verify/' + token)
    },

    /**
     * Resend verification e-mail.
     * @param email
     * @returns {AxiosPromise<any>}
     */
    resend(email) {
        return axios.post('/api/auth/verify/resend', { email })
    },

    /**
     * Get social provider redirect
     * @param provider
     */
    redirect(provider) {
        console.log('provider', provider);
        window.location = '/auth/oauth/' + provider
    },

    /**
     * Send social auth callback response to API for authentication or registration.
     * @param provider
     * @param query
     * @returns {AxiosPromise<any>}
     */
    callback(provider, query) {
        console.log('callback handler', provider, query);
        return axios.get('/auth/oauth/callback/' + provider, { params: query })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/auth.js